import { Injectable } from '@angular/core';

import { toCent } from '@frontend/sports/common/core/utils/math';
import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { BetslipListType } from '@frontend/sports/types/models/my-bets';

import { MyBetsBetSlip } from '../../../my-bets-base/models/my-bets-viewmodels';
import { MyBetsVisualizationTrackingService } from '../../services/my-bets-visualization-tracking.service';

@Injectable()
export class MyBetsListTrackingService {
    constructor(
        private trackingService: TrackingService,
        private myBetsVisualizationTrackingService: MyBetsVisualizationTrackingService,
    ) {}

    trackMyBetsTabsLoad(myBetsBetSlips: MyBetsBetSlip[], listType?: BetslipListType): void {
        myBetsBetSlips.forEach((betslip) => {
            const visualizationInfo = this.myBetsVisualizationTrackingService.getBetTypeInfo(betslip);
            const cashoutEnable = betslip.earlyPayout?.earlyPayoutPossible ? 'enable' : 'disable';
            const epAmount = toCent(betslip.earlyPayout?.valueWithoutStake || betslip.earlyPayout?.value || 0);

            const trackingData = {
                [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'betting',
                [trackingConstants.COMPONENT_ACTION_EVENT]: 'load',
                earlyPayoutAmount: epAmount,
                earlyPayoutSlipID: betslip.betslipRealId,
                [trackingConstants.COMPONENT_LOCATION_EVENT]: listType?.toLocaleLowerCase(),
                [trackingConstants.COMPONENT_POSITION_EVENT]: visualizationInfo,
                [trackingConstants.COMPONENT_EVENT_DETAILS]: listType !== BetslipListType.Settled ? `cashout - ${cashoutEnable} cta` : 'no cashout',
                [trackingConstants.COMPONENT_LABEL_EVENT]: 'mybets',
            };
            this.trackingService.track(trackingConstants.EVENT_CONTENT_VIEW, trackingData);
        });
    }
}
